import IconChevronRight from 'assets/icons/chevron-right-stroke.svg';
import { IBlogSectionCtaFields } from 'global';
import Image from 'modules/content-cms/sections/components/image';
import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

const BlogSectionCta: React.FC<IBlogSectionCtaFields> = (props) => {
  const {
    image,
    relatedArticleTitle,
    relatedArticleUrl,
    linkTarget,
    sectionTitle,
  } = props;

  return (
    <Link
      href={relatedArticleUrl}
      className="mb-4 flex w-full no-underline!"
      target={linkTarget}
    >
      <div className="relative w-2/4 lg:w-1/4">
        <Image
          {...image}
          layout="fill"
          objectFit="cover"
          className="rounded-l-md"
        />
      </div>

      <div className="text-primary-main flex w-full items-center justify-between rounded-r-md bg-[#F1C40F] px-2 text-lg lg:py-6">
        <div>
          <p className="font-black uppercase">
            {sectionTitle ?? (
              <FormattedMessage id="magazine:article-page:section-cta:default-title" />
            )}
          </p>
          <p className="mt-1!">{relatedArticleTitle}</p>
        </div>
        <IconChevronRight className="h-6 w-6 shrink-0" />
      </div>
    </Link>
  );
};

export default BlogSectionCta;
